var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg081IncreaseVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17H8.59L12.08 20.49C12.3988 20.8152 12.8346 20.9989 13.29 21C13.5139 20.9979 13.7351 20.9503 13.94 20.86C14.5826 20.5989 15.0021 19.9736 15 19.28V4.71999C15.0007 4.02783 14.5841 3.40352 13.9446 3.13855C13.3052 2.87358 12.5691 3.02021 12.08 3.50999L8.59 6.99999H5C3.34315 6.99999 2 8.34313 2 9.99999V14C2 15.6568 3.34315 17 5 17ZM4 9.99999C4 9.4477 4.44772 8.99999 5 8.99999H9C9.2658 9.00152 9.52128 8.89717 9.71 8.70999L13 5.40999V18.59L9.71 15.29C9.52128 15.1028 9.2658 14.9984 9 15H5C4.44772 15 4 14.5523 4 14V9.99999ZM20 9.99999V11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H20V14C20 14.5523 19.5523 15 19 15C18.4477 15 18 14.5523 18 14V13H17C16.4477 13 16 12.5523 16 12C16 11.4477 16.4477 11 17 11H18V9.99999C18 9.4477 18.4477 8.99999 19 8.99999C19.5523 8.99999 20 9.4477 20 9.99999Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg081IncreaseVolume);
export default __webpack_public_path__ + "static/media/081-increase-volume.a36a86bb0c0496c50d5283b9fdd51076.svg";
export { ForwardRef as ReactComponent };